<template>
    <div style="height: 100%;">
        <div v-if="activeThemeTab === 'activeFormatProjects'" style="height: 100%;">
            <activeFormatProjects />
        </div>
        <div v-if="activeThemeTab === 'formatsList'" style="height: 100%;">
            <formatsList />
        </div>
        <div v-if="activeThemeTab === 'activeProjectPages'" style="height: 100%;">
            <activeProjectPages />
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import activeFormatProjects from './activeFormatProjects.vue';
    import formatsList from './formatsList.vue';
    import activeProjectPages from './activeProjectPages.vue';
    
    export default {
        computed: {
            ...mapState([
                'activeThemeTab'
            ])
        },
        components: {
            activeFormatProjects,
            formatsList,
            activeProjectPages
        }
    }
</script>

<style lang="scss" scoped>
    // .tab_content > div {
    //     height: 100%;
    // }
</style>